export function proxy(getter) {
    return new Proxy({}, {
        get: (_, key) => getter(key),
    });
}
//# sourceMappingURL=proxy.js.map